import getScanDatasetsForProjectByFirebaseId from "../../services/getters/scan_dataset_getters/get_scan_datasets_for_project_by_firebase_id";
import loadScanDatasetsForProject from "../../actions/react_query/scan_datasets/load_scan_datasets_for_project";
import useQueryWithState from "../use_query_with_state";

const useScanDatasetsForProject = (projectId: string) => {
  return useQueryWithState(["useScanDatasetsForProject", [projectId]],
    loadScanDatasetsForProject,
    getScanDatasetsForProjectByFirebaseId,
    { enabled: !!projectId },
    { projectId },
    { projectId });
};

export default useScanDatasetsForProject;
